<!-- This component is used to display a page that informs users about removing their access to an account navigated from
Users > Remove from account
Accounts I have access to > Remove access. -->
<div class="container zci-margin-top c11n-space-stack-10x c11n-space--force">
    <div class="c11n-space-stack-4x">
        <zci-back-link [link]="'/' + backNavigationPath"></zci-back-link>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-8 col-xl-6 col-xxl-5 mx-auto">
        <div class="c11n-space-stack-3x d-flex justify-content-center">
            <img src="../../../../../../assets/phone-actions-question.svg" alt="" />
        </div>
        <h1 class="c11n-text-xl-headline c11n-space-stack-3x" data-cy="page-title">
            {{ grantorContent.edit_remove_user_access.removeYourAccessContactInfo.heading }}
        </h1>
        <p
            class="c11n-space-stack-6x description-text"
            [innerHtml]="description"
            data-cy="page-description"
        ></p>
    </div>
</div>
